import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";

const normalizeEnvValue = (value = "") => value.toString().replace(/^['"]|['"]$/g, "").trim();

const useGetToken = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    if (inProgress !== "none" || accounts.length === 0) return;

    const configuredScopes = (process.env.REACT_APP_TOKEN_SCOPE || "")
      .split(",")
      .map((scope) => normalizeEnvValue(scope))
      .filter(Boolean);

    const request = {
      scopes: configuredScopes.length > 0 ? configuredScopes : ["User.Read"],
      account: accounts[0],
    };

    instance
      .acquireTokenSilent(request)
      .then((response) => {
        setAccessToken(response.accessToken);
      })
      .catch((error) => {
        setAccessToken("");
        console.error("Failed to acquire token silently", error);
      });
  }, [instance, inProgress, accounts]);

  return accessToken;
};

const useGetTokenForImage = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    if (inProgress !== "none" || accounts.length === 0) return;

    const request = {
      scopes: ["User.Read"],
      account: accounts[0],
    };

    instance
      .acquireTokenSilent(request)
      .then((response) => {
        setAccessToken(response.accessToken);
      })
      .catch((error) => {
        setAccessToken("");
        console.error("Failed to acquire profile token", error);
      });
  }, [instance, inProgress, accounts]);

  return accessToken;
};

export { useGetToken, useGetTokenForImage };
